<template>
  <div>
    <v-container fluid>
      <v-card
        elevation="0"
        class="ma-0 pb-3"
        :saveLoading="$apollo.queries.getGeneralSettings.loading"
      >
        <v-card-title class="secondary--text font-weight-medium pt-5 pb-0">
          <v-row class="ma-0">
            <h3 class="my-2 primary--text">
              {{ $t("termsAndCondition.termsAndCondition") }}
            </h3>
          </v-row>
        </v-card-title>
        <v-row class="px-3">
          <v-col cols="6">
            <v-card flat>
              <v-card-title class="py-2 text-body-2 pl-0"> </v-card-title>
              <vue-editor ref="termsAndConditionEn" />
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card flat>
              <v-card-title class="py-2 text-body-2 pl-0"> </v-card-title>

              <vue-editor ref="termsAndConditionAr" />
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" class="py-3">
          <v-col cols="4">
            <v-btn
              width="100%"
              :disabled="!isFormValid"
              :loading="btnLoading"
              class="white--text rounded-lg mx-3"
              color="primary"
              @click="updatePrivacyPolicy"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { updateSettings } from "../../settings/methods/contactUs/update_settings";
import "@/core/methods/validations.js";
import { VueEditor } from "vue2-quill-editor";
export default {
  data() {
    return {
      TermsAndConditionValues: {
        termsAndConditionEn: null,
        termsAndConditionAr: null
      },
      saveLoading: false,
      btnLoading: false
    };
  },
  components: {
    VueEditor
  },
  computed: {
    isFormValid() {
      return (
        this.TermsAndConditionValues.termsAndConditionEn &&
        this.TermsAndConditionValues.termsAndConditionAr
      );
    },
    termsAndConditionEditors() {
      return [
        {
          title: this.$t("termsAndCondition.termsAndConditionEn"),
          type: "rtfEditor",
          modelMap: "termsAndConditionEn",
          attrs: {}
        },
        {
          title: this.$t("termsAndCondition.termsAndConditionAr"),
          type: "rtfEditor",
          modelMap: "termsAndConditionAr",
          attrs: {}
        }
      ];
    }
  },
  apollo: {
    getGeneralSettings() {
      this.saveLoading = true;
      return {
        query: require("@/settings/api/queries/contactUs/general_settings_query.graphql"),
        variables: {
          searchKey: this.search
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          this.TermsAndConditionValues = {
            ...this.TermsAndConditionValues,
            ...data.getGeneralSettings
          };
          this.initializeEditors();
          this.saveLoading = false;
        }
      };
    }
  },
  methods: {
    initializeEditors() {
      // Manually set initial content to ensure both editors render properly
      this.$nextTick(() => {
        if (
          this.$refs.termsAndConditionEn &&
          this.$refs.termsAndConditionEn.quill
        ) {
          this.$refs.termsAndConditionEn.quill.clipboard.dangerouslyPasteHTML(
            this.TermsAndConditionValues.termsAndConditionEn
          );
        }
        if (
          this.$refs.termsAndConditionAr &&
          this.$refs.termsAndConditionAr.quill
        ) {
          this.$refs.termsAndConditionAr.quill.clipboard.dangerouslyPasteHTML(
            this.TermsAndConditionValues.termsAndConditionAr
          );
        }
      });
    },
    updatePrivacyPolicy() {
      this.btnLoading = true;
      const quillInstanceEn = this.$refs.termsAndConditionEn.quill;
      const enText = quillInstanceEn.root.innerHTML;
      const quillInstanceAr = this.$refs.termsAndConditionAr.quill;
      const arText = quillInstanceAr.root.innerHTML;
      const updateInput = {
        id: this.TermsAndConditionValues._id,
        input: {
          termsAndConditionEn: enText,
          termsAndConditionAr: arText
        }
      };
      updateSettings(updateInput, this.search).then(response => {
        if (response.data) {
          this.btnLoading = false;
          this.$apollo.queries.getGeneralSettings.refetch({
            searchKey: this.search
          });
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("common.updateSuccess"),
            color: "green"
          });
        }
        if (response.graphQLErrors) {
          this.btnLoading = false;
          this.isError = response.graphQLErrors[0].message;
        }
      });
    }
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
